var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveSelection = function SvgRemoveSelection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.346 20.5-1.054-1.054 3.55-3.55-3.55-3.55 1.054-1.054 3.55 3.55 3.55-3.55 1.054 1.054-3.55 3.55 3.55 3.55-1.054 1.054-3.55-3.55zm-5 0v-1.616h1.615V20.5zM5.116 5.116H3.5q0-.667.474-1.141A1.56 1.56 0 0 1 5.116 3.5zm2.23 0V3.5h1.615v1.616zm3.846 0V3.5h1.616v1.616zm3.847 0V3.5h1.615v1.616zm3.845 0V3.5q.667 0 1.142.474.474.475.474 1.141zM5.116 18.885V20.5q-.667 0-1.141-.474a1.56 1.56 0 0 1-.475-1.142zM3.5 16.654v-1.615h1.616v1.615zm0-3.846v-1.616h1.616v1.616zm0-3.847V7.346h1.616v1.615zm15.385 0V7.346H20.5v1.615z"
  })));
};
export default SvgRemoveSelection;